export function isUndefined(o?: any): o is undefined {
    return typeof o === 'undefined';
}